import React, { useState, useEffect } from "react";
import { logger } from "../services/LogService";
import EATextField from "../components/EATextField";
import routes from "../consts/routes.json";
import EANavButton from "../components/EANavButton";
import "../styles/views/login.css";
import { toast } from "react-toastify";
import { logout } from "../services/JwtService";
import queryString from "query-string";
import { requiredString, validate } from "../utils/Validator";
import * as authService from "../services/AuthService";
import EAButton from "../components/EAButton";

const schema = {
    username: requiredString("Benutzername"),
    password: requiredString("Passwort"),
};

function LoginView(props) {
    const { state } = props.location;

    const [errors, setErrors] = useState({});
    const [userData, setUserData] = useState({ username: "", password: "" });
    const [idleLogin, setIdleLogin] = useState(false);

    const { ticket } = queryString.parse(props.location.search);

    const [isEmbedded, setIsEmbedded] = useState(false);

    useEffect(() => {
        if (ticket) {
            logger.debug("Login with ticket", ticket);
            setIdleLogin(true);
            logout();
            authService
                .sso(ticket)
                .then(() => {
                    props.history.push(routes.STARTSEITE);
                })
                .catch((e) => {
                    if (e?.response?.status === 403) {
                        toast.error("Sie konnten nicht per SSO angemeldet werden");
                    }
                    setIdleLogin(false);
                    props.history.push(routes.LOGIN);
                });
        }
    }, [props.location.search, props.history, ticket]);

    useEffect(() => {
        const currentURL = window.location.href;
        setIsEmbedded(currentURL.includes(routes.LOGIN_EMBEDDED));
    }, []);

    function handleLogin(event) {
        logger.debug("Login event");
        event.preventDefault();
        logger.debug("setIdleLogin");
        setIdleLogin(true);
        const newErrors = validate({ ...userData }, schema);
        logger.debug("valid userData");
        setErrors(newErrors || {});
        if (newErrors) {
            logger.debug("new Errors");
            setIdleLogin(false);
            return;
        }

        authService
            .login(userData.username, userData.password)
            .then(() => {
                logger.debug("state: ", state);
                if (state && state?.from?.pathname !== routes.UNAUTORISIERT) {
                    props.history.push(state.from.pathname);
                } else {
                    if (isEmbedded) {
                        window.open(routes.EABWASSER, "_blank");
                        props.history.push(routes.LOGGED_IN_EMBEDDED);
                    }
                    else {
                        props.history.push(routes.STARTSEITE);
                    }
                }
            })
            .catch((error) => {
                logger.debug("login Error");
                if (error.response && error.response.data) {
                    setErrors(error.response.data.validationErrors || {});
                }
                setIdleLogin(false);
            });
    }

    useEffect(() => {
        if (window.self !== window.top) {
            if (!isEmbedded) {
                props.history.push(routes.LOGIN_EMBEDDED);
            }
        }
    }, [isEmbedded, props.history]);

    return (
        <div id="loginLayout" className="viewContent gridl">
            {ticket && <div />}
            {!ticket && (
                <form id="loginForm" onSubmit={handleLogin} className="gridl">
                    {window.location.href.includes("eabwasser-stage") && (
                        <span className={'warning'}>
                            ACHTUNG TESTSYSTEM
                        </span>
                    )}
                    <EATextField
                        id="username"
                        label="Benutzername"
                        error={errors.username}
                        value={userData.username}
                        disabled={idleLogin}
                        autoComplete="username"
                        onChange={(e) => setUserData({ ...userData, username: e.target.value })}
                        autoFocus
                        required
                    />
                    <EATextField
                        id="password"
                        autoComplete="current-password"
                        label="Passwort"
                        disabled={idleLogin}
                        error={errors.password}
                        value={userData.password}
                        onChange={(e) => setUserData({ ...userData, password: e.target.value })}
                        type="password"
                        required
                    />
                    <EAButton
                        loading={idleLogin}
                        disabled={idleLogin}
                        type="submit"
                        onClick={handleLogin}
                        form="loginForm"
                        id="loginButton"
                        label="Anmelden"
                        color="primary"
                    />
                </form>
            )}
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                {isEmbedded && <EANavButton style={{ display: 'inline-block' }} to={routes.REGISTRATION_EMBEDDED}>Zugang beantragen</EANavButton>}
                {!isEmbedded && <EANavButton style={{ display: 'inline-block' }} to={routes.REGISTRATION}>Zugang beantragen</EANavButton>}
                {!isEmbedded && <EANavButton style={{ display: 'inline-block' }} to={routes.RESET_PASSWORD}>Passwort vergessen</EANavButton>}
            </div>
            <p>
                <strong>Hinweis:</strong>
                <br />
                Um die Anwendung nutzen zu können, müssen im Browser <strong>Cookies</strong> und <strong>Javascript</strong> aktiviert
                sein.
            </p>
        </div>
    );
}

export default LoginView;
